export const getProductReviews = (id: number, page: number) => ({
  type: "@saga/GET_PRODUCT_REVIEWS",
  payload: { id, page },
});
